import { useConfig } from 'providers/config/ConfigProvider';
import { useGetBranding } from '@sanlam-glacier/app-common/modules/theme';
import './comingSoon.style.scss';

export const ComingSoon = () => {
  const { theme } = useConfig();
  const { comingSoon } = useGetBranding(theme);
  return (
    <div
      aria-label='Coming soon'
      className='full-page-image'
      style={{ backgroundImage: `url(${comingSoon})` }}
    />
  );
};
